/**
 * A tela que ainda nao existe.
 *
 * Existe **em vez de** um dashboard com graficos zerados ou um "Em breve" decorativo. Duas razoes:
 *
 * 1. O §4 da spec 04 e' explicito — tela de tenant sem canal *"nao e' um dashboard vazio com
 *    graficos zerados"*. Um placeholder que finge dado ensina a nao confiar na tela.
 * 2. Quem abrir isto — o owner, ou um agente entrando frio — precisa saber **onde esta o desenho** e
 *    **qual item do BACKLOG** constroi. Um "Em breve" nao responde nenhuma das duas.
 */

import { Botao, textos } from "@hugi/ui";

export function AindaNaoConstruida(props: {
  readonly titulo: string;
  readonly spec: string;
  readonly item: string;
}) {
  return (
    <section className="mx-auto max-w-prose px-6 py-12">
      <h1 className="text-lg font-semibold">{props.titulo}</h1>
      <p className="mt-3 text-sm text-[color:var(--tinta-fraca)]">
        Esta tela está <strong>desenhada e não construída</strong>. A fundação (H22) é o que existe
        hoje: sessão, permissão, os dez estados obrigatórios e a moldura.
      </p>
      <dl className="mt-4 space-y-1 text-sm">
        <div className="flex gap-2">
          <dt className="text-[color:var(--tinta-fraca)]">Desenho:</dt>
          <dd>
            <code className="rounded bg-[color:var(--vidro-controle)] px-1.5 py-0.5 text-xs">{props.spec}</code>
          </dd>
        </div>
        <div className="flex gap-2">
          <dt className="text-[color:var(--tinta-fraca)]">Item do BACKLOG:</dt>
          <dd className="font-medium">{props.item}</dd>
        </div>
      </dl>
      <div className="mt-6">
        <Botao tipo="secundario" onClick={() => window.history.back()}>
          {textos.acoes.voltar}
        </Botao>
      </div>
    </section>
  );
}
